import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=08633b06&scoped=true"
import script from "./Concept.vue?vue&type=script&lang=js"
export * from "./Concept.vue?vue&type=script&lang=js"
import style0 from "./Concept.vue?vue&type=style&index=0&id=08633b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08633b06",
  null
  
)

export default component.exports